import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import SVG from 'react-inlinesvg';

import { colors } from '../../utils';

const AlertStyled = styled.section`
  background: #fff;
  border-radius: 2px;
  border-top: 2px solid;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
  display: flex;
  margin: 0 0 1rem;
  padding: 1rem;

  div {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  ${props => {
    if (props.status) {
      return `
        border-top-color: ${colors[props.status]};
        svg {
          fill: ${colors[props.status]};
        }
      `;
    }
    return 'border-top-color: #333541';
  }};

  .isvg {
    align-items: center;
    display: flex;
    margin-right: 0.25rem;
  }

  svg {
    height: 1rem;
    width: 1rem;
  }
`;

const Alert = props => (
  <AlertStyled status={props.status} color={props.color}>
    <If condition={props.status === 'error'}>
      <SVG
        cacheGetRequests
        src={require('../../../assets/icons/attention-alt.svg')}
      />
    </If>
    <div>{props.children || props.message}</div>
  </AlertStyled>
);

export default Alert;

Alert.defaultProps = {
  children: null,
  message: null,
  status: null,
};

Alert.propTypes = {
  children: PropTypes.node,
  message: PropTypes.node,
  status: PropTypes.oneOf(['', 'success', 'error', 'warning', 'info']),
};
